import React from 'react'
import PropTypes from 'prop-types';

import moment from 'moment'

class CalendarView extends React.Component {
    static KEY = 0

    static propTypes = {
        day: PropTypes.instanceOf(moment),
        collection: PropTypes.array,
        isWeekend: PropTypes.bool,
        monthName: PropTypes.string,
        dayOfMonth: PropTypes.number
    }

    constructor(props){
        super(props)
        this.day = props.day;
        this.collection = props.collection;
        this.isWeekend = [6, 7].includes(this.day.isoWeekday());
        this.monthName = this.day.format('ddd');
        this.dayOfMonth = this.day.format('DD');
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.collection = nextProps.collection
    }

    filterDay(event) {
        const {startAt, endAt} = event
        return !this.day.isBefore(startAt, 'day') && !this.day.isAfter(endAt, 'day')
    }

    renderDay(event) {
        const {_id} = event.props
        const key = 'calendar-' + (CalendarView.KEY++)

        if(this.filterDay(event.props)) {
            return <div key={key}>{React.createElement(event.type, {...event.props, dayPrinted: this.day})}</div>
        }

        return <div className='event-empty' key={key + '-empty'}></div>
    }

    render() {
        throw new Error("Render function is not override")
    }
}

export default CalendarView
